import { render, staticRenderFns } from "./UserEmailConfirm.vue?vue&type=template&id=9638c048"
import script from "./UserEmailConfirm.vue?vue&type=script&lang=js"
export * from "./UserEmailConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports